'use strict';

module.exports = {
    init: function() {
        $(".nav-link").on("click", function() {
            $(".close-menu .back").css("display", "inline-block");
        });

        $(".close-menu .back").on("click", function() {
            $(".close-menu .back").css("display", "none");
        });
    }
};
